if (!customElements.get('collection-banners')) {
  class CollectionBanners extends HTMLElement {
    constructor() {
      super();

      this.setupCarousel();
    }

    setupCarousel() {
      const carouselID = this.dataset.selector;

      if (!carouselID) return;

      requirejs(['swiper'], (Swiper) => {
        this.collectionBannerSwiper = new Swiper(`.js-carousel-${carouselID}`, {
          grabCursor: false,
          lazy: true,
          resistanceRatio: 0.4,
          speed: 300,
          loop: false,
          slidesPerView: 3.2,
          spaceBetween: 16,

          pagination: {
            el: `.js-swiper-pagination-${carouselID}`,
            clickable: true,
            type: 'progressbar'
          },
          navigation: {
            nextEl: `.js-swiper-next-${carouselID}`,
            prevEl: `.js-swiper-prev-${carouselID}`
          },
          breakpoints: {
            960: {
              spaceBetween: 20,
              slidesPerView: 4.2
            },
            1280: {
              slidesPerView: 7.2
            }
          }
        });
      });
    }
  }

  customElements.define('collection-banners', CollectionBanners);
}
